import { React, useRef } from 'react';
import { Header, Portfolio, Profiles, Contact, Footer, Wave, Navbar } from "../../components";
import "./home.css";

const Home = () => {
    const resultRef = useRef(null);

    return (
        <div className="bg">
            <Navbar />
            <Header resultRef={resultRef} />
            <Portfolio />
            <Profiles />
            <Wave />
            <Contact ref={resultRef} />
            <Footer />
        </div>
    )
}

export default Home
